import styled from "styled-components";

export const EorPartnerPaidContainer = styled.div`
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.grayDivider};
  border-radius: 8px;
  padding: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 32px;
  .label {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    h1{
      font-size: 19px;
      font-weight: 700;
      line-height: 23px;
      letter-spacing: 0.4px;
      text-align: left;
      color: ${({theme}) => theme.black};
    }
    h3{
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 22px;
      letter-spacing: 0.3px;
      color: ${({theme}) => theme.grayLight};
    }
    p {
      padding: 0 32px 0 32px;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 22px;
      letter-spacing: 0.3px;
      color: ${({theme}) => theme.grayLight};
    }
  }
  .action{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    flex-direction: column;
    .label{
      width: 100%;
    }
    .action {
      width: 100%;
      button {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
`
